import request from "@/config/request";
import {
  getCustomer,
  bookOrder,
  getOrder,
  Paganation,
  updateReceipt,
  takeorder,
  openId,
  unBandCar,
  OrderDetail,
} from "./interface";

export const getFactoryList = () =>
  request({
    url: "/wxgzh/getFactoryList",
    method: "post",
  });

export const getCustomerList = (data: getCustomer) =>
  request({
    url: "/wxgzh/getCustomerListByPlateNumber",
    method: "post",
    data,
  });

export const getStoneList = (data: {
  factory_id: string;
  customer_id: string;
}) =>
  request({
    url: "/wxgzh/customerStoneList",
    method: "post",
    data,
  });

export const orderBook = (data: bookOrder) =>
  request({
    url: "/wxgzh/gzhOrderAdd",
    method: "post",
    data,
  });

export const getOrderInfo = (data: getOrder) =>
  request({
    url: "/wxgzh/query",
    method: "post",
    data,
  });

export const getPurseOrderInfo = (data: getOrder) =>
  request({
    url: "/wxgzh/purseQuery",
    method: "post",
    data,
  });

export const orderList = (data: Paganation) =>
  request({
    url: "/wxgzh/orderListByUnionid",
    method: "post",
    data,
  });

export const takeOrder = (data: takeorder) =>
  request({
    url: "/wxgzh/receiptnewWx",
    method: "post",
    data,
  });

export const cancelOrder = (data: takeorder) =>
  request({
    url: "/wxgzh/refuseOrder",
    method: "post",
    data,
  });

export const delOrder = (data: { order_id: string }) =>
  request({
    url: "/wxgzh/cancelOrder",
    method: "post",
    data,
  });

export const getPlateList = (data: openId) =>
  request({
    url: "/wxgzh/carList",
    method: "post",
    data,
  });

export const relieveBand = (data: unBandCar) =>
  request({
    url: "/wxgzh/unbunCar",
    method: "post",
    data,
  });

export const orderDetail = (data: OrderDetail) =>
  request({
    url: "/wxgzh/wxReportDetail",
    method: "post",
    data,
  });

export const uploadVoucher = (data: updateReceipt) =>
  request({
    url: "/wxgzh/uploadingVoucher",
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  });
